import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';

import PremiumApp from './pages/product/PremiumApp';
import Desktop from './pages/product/Desktop';
import Lens from './pages/product/Lens';
import StaffApp from './pages/product/StaffApp';

function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));

      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

        // Remove #contact from the URL immediately
        window.history.replaceState(null, "", pathname);
      }
    }
  }, [hash, pathname]);

  return null;
}
function ScrollToTopOnRefresh() {
  useEffect(() => {
    window.history.scrollRestoration = "manual";
    window.scrollTo(0, 0);
  }, []);

  return null;
}

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    if (location.pathname === "/") {
      const element = document.getElementById(id);

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <>
      <ScrollToTopOnRefresh />
      <ScrollToHash />
      <Header scrollToSection={scrollToSection} />
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/product/premium-app" element={<PremiumApp />} />
        <Route path="/product/desktop" element={<Desktop />} />
        <Route path="/product/lens" element={<Lens />} />
        <Route path="/product/staff-app" element={<StaffApp />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
